import { atom } from 'recoil';

const questionInGuidanceModeState = atom({
    key: 'projectManager_projectDataManagement_questionnaireQuestionInGuidanceMode',
    default: null,
});

export default questionInGuidanceModeState;
